<template>
  <div class="login">
    <div class="back">
        <img src='../assets/back.jpg' width="100%" height="100%" alt="" />
    </div>
    <div class="logo">
         <img src='../assets/logo22.png'  alt="" class="logopic"/>
    </div>
    <div class="loginbox" v-show="isShow">
        <el-tabs v-model="activeName" @tab-click="handleClick" class="boxtabs" >
            <el-tab-pane label="密码登录" name="first">
                <div class="passLogin">
                    <el-input v-model="username" placeholder="用户名"></el-input>
                    <el-input placeholder="密码" v-model="password" class="password_input">
                        <el-button slot="append">忘记密码</el-button>
                    </el-input>
                    <el-button type="primary" class="passButton">登录</el-button>
                    <div class="register"  @click="getReg">注册</div>
                </div>
            </el-tab-pane>
            <el-tab-pane label="验证码登录" name="second">
                 <div class="passLogin">
                      <el-input placeholder="手机号" v-model="phoneNum">
                        <el-button slot="append">获取验证码</el-button>
                    </el-input>
                    <el-input v-model="code" placeholder="验证码"  class="password_input"></el-input>
                    <el-button type="primary" class="passButton">登录</el-button>
                    <div class="register" @click="getReg">注册</div>
                </div>
            </el-tab-pane>
        </el-tabs>
      
    </div>
    <div class="registerBox"  v-show="elseShow">
        <el-form :model="ruleForm" :rules="rules" ref="ruleForm"  class="demo-ruleForm" :inline="true">
            <el-form-item prop="name">
                <el-input v-model="ruleForm.name" placeholder="用户名" style="width: 300px"></el-input>
            </el-form-item>
            <el-form-item prop="pass">
                <el-input type="password" v-model="ruleForm.pass" autocomplete="off" placeholder="密码" style="width: 300px"></el-input>
            </el-form-item>
            <el-form-item prop="checkPass">
                <el-input type="password" v-model="ruleForm.checkPass" autocomplete="off" placeholder="重输密码" style="width: 300px"></el-input>
            </el-form-item>
            <el-form-item prop="phone">
                <el-input v-model="ruleForm.phone" placeholder="手机号" style="width: 300px"></el-input>
            </el-form-item>
            <el-form-item prop="code">
              <el-input placeholder="验证码" v-model="ruleForm.code" style="width: 300px">
                      <el-button slot="append">获取验证码</el-button>
                  </el-input>
            </el-form-item>
             <el-form-item>
                    <el-input
                        placeholder="QQ号"
                        v-model="ruleForm.qqNum"
                        style="width: 150px">
                    </el-input>
              </el-form-item>
            <el-form-item>
                    <el-input
                        placeholder="微信"
                        v-model="ruleForm.wechatNum"
                        style="width: 150px">
                    </el-input>
            </el-form-item>
  
        </el-form>
        <el-checkbox v-model="checked" class="registerchecked">我已阅读并同意<a href="" style=" text-decoration: none">《智汇众盈传媒·用户注册协议》</a></el-checkbox>
        <el-button type="primary" class="regButton">确定注册</el-button>
        <div class="register" @click="getLogin">已有帐号，登录</div>
    </div>
  </div>
</template>

<script>
export default {
    name: 'Login',
    data() {
            var validatePass = (rule, value, callback) => {
            if (value === '') {
            callback(new Error('请输入密码'));
            } else {
            if (this.ruleForm.checkPass !== '') {
                this.$refs.ruleForm.validateField('checkPass');
            }
            callback();
            }
        };
        var validatePass2 = (rule, value, callback) => {
            if (value === '') {
            callback(new Error('请再次输入密码'));
            } else if (value !== this.ruleForm.pass) {
            callback(new Error('两次输入密码不一致!'));
            } else {
            callback();
            }
        };
        
        return {
            isShow: true,
            elseShow: false,
            activeName: 'first',
            username: '',
            password: '',
            phoneNum: '',
            code: '',
            ruleForm: {
                name: '',
                pass: '',
                checkPass: '',
                phone: '',
                code: '',
                qqNum: '',
                wechatNum: ''
             },
             rules: {
                name: [
                    { required: true, message: '请输入用户名', trigger: 'blur' }
                ],
                pass: [
                    { validator: validatePass, trigger: 'blur' }
                ],
                checkPass: [
                    { validator: validatePass2, trigger: 'blur' }
                ],
                phone: [
                    { required: true, message: '请输入电话号码', trigger: 'blur' },
                    { min: 11, max: 11, message: '号码应为11位', trigger: 'blur' }
                ],
                code: [
                    { required: true, message: '请输入验证码', trigger: 'blur' }
                ]
            }
          };
        },
    methods: {
        handleClick(tab, event) {
            console.log(tab, event);
        },
        getReg(){
            // alert('进去了');
            this.isShow = false;
            this.elseShow = true;
        },
        getLogin(){
             this.isShow = true;
            this.elseShow = false;
        }
        

    }
}

</script>
<style scoped>
*{
    margin: 0;
    padding: 0;
}
a{
    color: #ff0000;
}
.back{
    width:100%;  
    height:100%;  
    z-index:-1;
    position: absolute;
}
.logo{
     position: absolute;
     left: 139px;
}
.logopic{
   width: 206px;
    /* height: 162px; */
}
.loginbox{
    background-color: rgba(255,255,255,0.95);
    width: 360px;
    min-height: 295px;
    position: absolute;
    top: 28%;
    right:170px;
    border-radius: 6px;
}
.boxtabs{
    margin-top: 30px;
    margin-left: 36px;
    margin-right: 38px;
}
.passLogin{
    margin-top: 5px;
}
.password_input{
    margin-top: 16px;
}
/* .registerchecked{
    margin-left: 36px;
} */
.passButton{
    width: 286px ;
    margin-top: 16px;
}
.register{
    font-size: 14px;
    color: #000000;
    margin-top: 10px;
    text-align: center;
}
.registerBox{
    width: 300px;
    height: 435px;
    background-color: rgba(255,255,255,0.95);
    position: absolute;
    top: 85px;
    right:170px;
    border-radius: 6px;
    padding:30px 30px 0px 30px;

}
.regButton{
   /* margin-left: 36px; */
    width: 286px ;
    margin-top: 12px;
}

.el-form-item{
    margin-bottom: 12px;
}
/deep/.el-form-item__error{
    font-size: 10px; 
    padding-top: 1px;
}
.el-form--inline .el-form-item{
    margin-right: 0px;
}
</style>
